import { render } from "./ModalModificaPrenotazione.vue?vue&type=template&id=25fc0e65&scoped=true"
import script from "./ModalModificaPrenotazione.vue?vue&type=script&lang=js"
export * from "./ModalModificaPrenotazione.vue?vue&type=script&lang=js"

import "./ModalModificaPrenotazione.vue?vue&type=style&index=0&id=25fc0e65&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_v2/app_ambient/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25fc0e65"]])

export default __exports__